import { fetchProviders } from "../misc/fetchProviders";
import React, { useCallback, useState } from "react";
import { useAsync } from "../hooks/useAsync";
import { WaterProvider } from "../misc";
export const AllProvidersRequestor: React.FC<{}> = ({ children }) => {
    const load = useCallback(async (signal?: AbortSignal): Promise<WaterProvider[]> => {
        return fetchProviders({
            signal
        });
    }, []);

    const [providers, setProviders] = useState<WaterProvider[]>();

    useAsync(load, setProviders);

    if (!providers?.length) return <div>...Loading</div>;
    return <>{children}</>;
};
